import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountSetupComponent } from './components/account-setup.component';
import { AcceptInviteComponent } from './components/accept-invite/accept-invite.component';
import { SignupInviteComponent } from './components/signup-invite/signup-invite.component';
import { EmailConfirmationFlowComponent } from './components/email-confirmation-flow/email-confirmation-flow.component';
import { PasswordSetupComponent } from './components/password-setup/password-setup.component';
import { SuccessScreenComponent } from './components/success-screen/success-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { InviteExpiredComponent } from './components/invite-expired/invite-expired.component';
import { RouterModule } from '@angular/router';
import { WeKnowYouComponent } from './components/we-know-you/we-know-you.component';
import { ExtraInformationComponent } from './components/extra-information/extra-information.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { LookupUserComponent } from './components/create-account/lookup-user/lookup-user.component';
import { VerifyOTPComponent } from './components/create-account/verify-otp/verify-otp.component';
import { PasswordFormModule } from '../../shared/password/password-form/password-form.module';
import { ContactSetupComponent } from './components/create-account/contact-setup/contact-setup.component';
//import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { RecaptchaModule } from 'ng-recaptcha';
import { SuccessStepComponent } from './components/create-account/success-step/success-step.component';
import { SecurityVerificationComponent } from './components/create-account/security-verification/security-verification.component';
import { CreateOTPComponentV0 } from './components/create-account-v0/create-otp/create-otp.component';
import { VerifyOTPComponentV0 } from './components/create-account-v0/verify-otp/verify-otp.component';
import { CreateAccountComponentV0 } from './components/create-account-v0/create-account.component';
import { ContactSetupComponentV0 } from './components/create-account-v0/contact-setup/contact-setup.component';
import { SuccessStepComponentV0 } from './components/create-account-v0/success-step/success-step.component';
import { ReviewContactComponent } from './components/create-account/review-contact/review-contact.component';
import { ReviewAddressComponent } from './components/create-account/review-address/review-address.component';

@NgModule({
  declarations: [
    AcceptInviteComponent,
    AccountSetupComponent,
    CreateAccountComponent,
    LookupUserComponent,
    SecurityVerificationComponent,
    VerifyOTPComponent,
    ReviewContactComponent,
    ReviewAddressComponent,
    ContactSetupComponent,
    EmailConfirmationFlowComponent,
    InviteExpiredComponent,
    PasswordSetupComponent,
    SignupInviteComponent,
    SuccessScreenComponent,
    WeKnowYouComponent,
    ExtraInformationComponent,
    SuccessStepComponent,
    CreateAccountComponentV0,
    CreateOTPComponentV0,
    VerifyOTPComponentV0,
    ContactSetupComponentV0,
    SuccessStepComponentV0
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    SharedModule,
    PasswordFormModule,
    //GooglePlaceModule,
    RecaptchaModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class OnboardingModule { }
